/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from "react"
import { useParams } from "react-router-dom"

import { Loader, LoaderSize } from "@izettle/react"

import { Page, PageView } from "@/core/components/shared"
import { useSellerInfo } from "@/modules/sign-up/api/use-seller-info"
import { EmptyState } from "@/modules/sign-up/components/empty-state"
import { ErrorState } from "@/modules/sign-up/components/error-state"
import { PolicyContent } from "@/modules/sign-up/components/policy-content"

import { FailureMessage } from "../api/types"
import {
  TrackingAction,
  useSignUpTracking,
  PrivacyPolicyFrom,
} from "../hooks/tracking-sign-up"

export const SellerPrivacyPage = () => {
  const { orgUuid } = useParams<{
    orgUuid: string
  }>()

  if (!orgUuid) {
    return <EmptyState />
  }

  const { track } = useSignUpTracking()

  const { isFetching, data } = useSellerInfo(orgUuid)

  const {
    orgName = "",
    orgPhoneNumber,
    orgContactEmail,
    orgPrivacyPolicyLink,
    failureMessage,
  } = data ?? {}

  useEffect(() => {
    track(TrackingAction.ViewedPrivacyPolicy, {
      page: PrivacyPolicyFrom.SellerPrivacyPage,
      sellerHasPrivacyPolicy: !!orgPrivacyPolicyLink,
    })
  }, [])

  if (failureMessage === FailureMessage.SELLER_NOT_FOUND) {
    return <EmptyState />
  }

  if (failureMessage) {
    return <ErrorState />
  }

  if (isFetching) {
    return (
      <Page data-testid="loading">
        <Loader size={LoaderSize.Large} />
      </Page>
    )
  }

  return (
    <PageView>
      <PolicyContent
        orgName={orgName}
        phone={orgPhoneNumber}
        email={orgContactEmail}
        linkToMerchantPrivacyPolicy={orgPrivacyPolicyLink}
      />
    </PageView>
  )
}
